/* LeGarage / Prestige : sélection de lignes sans remplacer le checkout Shopify.
   Les articles décochés sont sauvegardés sur le même navigateur avant retrait
   temporaire au checkout, puis réintégrés à la prochaine visite storefront.
   Ne pas charger ce script avec plusieurs instances. */
(() => {
  'use strict';
  if (window.__lgCartSelectionLoaded) return;
  window.__lgCartSelectionLoaded = true;

  const storageKey = 'lg-cart-selection-v1';
  const pendingKey = 'lg-cart-selection-pending-v1';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const endpoint = (path) => root + path;
  let state = { excludedKeys: [], excludedSignatures: [] };
  let cartCache = null;
  let working = false;
  let updateTimer = null;
  let pendingRefresh = false;
  let ready = false;
  let storageAvailable = false;

  const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
  const setText = (node, text) => { if (node.textContent !== text) node.textContent = text; };
  const excludedKeys = () => new Set(state.excludedKeys);
  const excludedSignatures = () => new Set(state.excludedSignatures);
  const allNodes = (sel) => Array.from(document.querySelectorAll(sel));
  const shopCurrency = (cart) => cart.currency || 'EUR';
  const format = (cents, cart) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: shopCurrency(cart)
      }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return ((Number(cents) || 0) / 100).toFixed(2) + ' €';
    }
  };
  const planId = (item) =>
    item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? String(item.selling_plan_allocation.selling_plan.id) : '';
  const signature = (item) => JSON.stringify([
    String(item.variant_id || item.id),
    planId(item),
    Object.entries(item.properties || {}).sort((a, b) => a[0].localeCompare(b[0]))
  ]);
  const isExcluded = (item) => excludedKeys().has(String(item.key)) ||
    excludedSignatures().has(signature(item));
  const read = (name) => {
    try { return JSON.parse(localStorage.getItem(name) || 'null'); } catch (_) { return null; }
  };
  const store = (name, value) => {
    localStorage.setItem(name, JSON.stringify(value));
  };
  function saveState() { store(storageKey, state); }
  function failureText(message) {
    allNodes('[data-lg-selection-error]').forEach((node) => {
      setText(node, message || '');
      node.hidden = !message;
    });
  }
  async function api(path, payload) {
    const result = await fetch(endpoint(path), {
      method: payload ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: payload ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
      body: payload ? JSON.stringify(payload) : undefined
    });
    if (!result.ok) throw new Error('Erreur Shopify (' + result.status + ')');
    return result.json();
  }
  async function fetchCart() { return api('cart.js'); }

  function visibleRows() { return allNodes('[data-lg-line-key]'); }

  function updateStateFor(key, selected) {
    const item = cartCache && cartCache.items.find((line) => String(line.key) === key);
    const keys = excludedKeys();
    const sigs = excludedSignatures();
    if (selected) {
      keys.delete(key);
      if (item) sigs.delete(signature(item));
    } else {
      keys.add(key);
      if (item) sigs.add(signature(item));
    }
    state = { excludedKeys: Array.from(keys), excludedSignatures: Array.from(sigs) };
    saveState();
  }
  function syncUI() {
    if (!ready || !cartCache || working) return;
    const cart = cartCache;
    const excluded = cart.items.filter(isExcluded);
    const selected = cart.items.filter((line) => !isExcluded(line));
    const partial = excluded.length > 0;
    const selectedCount = selected.reduce((n, line) => n + line.quantity, 0);
    const total = partial
      ? selected.reduce((n, line) => n + Number(line.final_line_price || 0), 0)
      : Number(cart.total_price || 0);

    document.body.dataset.lgCartSelectionReady = 'true';
    document.body.dataset.lgCartSelectionPartial = String(partial);
    visibleRows().forEach((row) => {
      const key = row.dataset.lgLineKey || '';
      const line = cart.items.find((value) => String(value.key) === key);
      const active = line ? !isExcluded(line) : !excludedKeys().has(key);
      const checkbox = row.querySelector('[data-lg-select-item]');
      if (checkbox && checkbox.checked !== active) checkbox.checked = active;
      if (row.dataset.lgSelected !== String(active)) row.dataset.lgSelected = String(active);
    });
    allNodes('[data-lg-select-all]').forEach((input) => {
      const checked = excluded.length === 0;
      if (input.checked !== checked) input.checked = checked;
      input.indeterminate = excluded.length > 0 && selected.length > 0;
    });
    allNodes('[data-lg-selected-count]').forEach((node) => setText(node,
      selectedCount + ' sur ' + cart.item_count + ' article(s)'));
    // Réutiliser le total natif de la page panier au lieu d'ajouter un récapitulatif.
    allNodes('[data-lg-native-total-price]').forEach((node) => {
      if (!node.dataset.lgOriginalPrice) node.dataset.lgOriginalPrice = node.textContent;
      setText(node, partial ? format(total, cart) : node.dataset.lgOriginalPrice);
    });
    allNodes('form.cart-page button[name="checkout"], form.cart-drawer__footer button[name="checkout"]').forEach((button) => {
      if (button.disabled !== (selectedCount === 0)) button.disabled = selectedCount === 0;
      button.setAttribute('aria-disabled', String(selectedCount === 0));
    });
    allNodes('.cart-drawer__button-price').forEach((node) => {
      if (!node.dataset.lgOriginalPrice) node.dataset.lgOriginalPrice = node.textContent;
      setText(node, partial ? format(total, cart) : node.dataset.lgOriginalPrice);
    });
  }
  function refreshSoon() {
    if (!ready || working) return;
    if (updateTimer) clearTimeout(updateTimer);
    updateTimer = setTimeout(async () => {
      updateTimer = null;
      if (pendingRefresh) return;
      pendingRefresh = true;
      try {
        cartCache = await fetchCart();
        syncUI();
      } catch (error) {
        failureText('Impossible de vérifier le panier. Actualise la page avant de continuer.');
      } finally { pendingRefresh = false; }
    }, 180);
  }

  async function restorePending() {
    const saved = read(pendingKey);
    if (!saved || !Array.isArray(saved.lines) || saved.lines.length === 0) return false;
    const cart = await fetchCart();
    for (const savedLine of saved.lines.slice()) {
      const existing = cart.items.find((line) => signature(line) === savedLine.signature);
      const already = existing ? Number(existing.quantity) : 0;
      const missing = Math.max(0, Number(savedLine.quantity) - already);
      if (missing > 0) {
        const payload = { id: Number(savedLine.id), quantity: missing };
        if (savedLine.properties && Object.keys(savedLine.properties).length) payload.properties = savedLine.properties;
        if (savedLine.selling_plan) payload.selling_plan = Number(savedLine.selling_plan);
        await api('cart/add.js', { items: [payload] });
      }
      // Chaque ligne restaurée est enregistrée immédiatement pour limiter
      // les doublons si la prochaine requête échoue.
      saved.lines = saved.lines.filter((line) => line !== savedLine);
      if (saved.lines.length) store(pendingKey, saved);
      else localStorage.removeItem(pendingKey);
    }
    return true;
  }

  async function beginPartialCheckout() {
    if (working || !ready) return;
    working = true;
    failureText('');
    allNodes('form.cart-page button[name="checkout"], form.cart-drawer__footer button[name="checkout"]').forEach((b) => { b.disabled = true; });
    try {
      if (read(pendingKey)) throw new Error('Des articles attendent leur restauration. Actualise ton panier.');
      const current = await fetchCart();
      const removed = current.items.filter(isExcluded);
      const selected = current.items.filter((line) => !isExcluded(line));
      if (!selected.length) throw new Error('Sélectionne au moins un article pour passer commande.');
      if (!removed.length) throw new Error('La sélection a changé. Actualise le panier puis réessaie.');

      const pending = { startedAt: Date.now(), lines: removed.map((line) => ({
        id: line.variant_id || line.id,
        quantity: Number(line.quantity),
        properties: line.properties || {},
        selling_plan: planId(line),
        signature: signature(line)
      })) };
      store(pendingKey, pending); // Toujours sauvegarder AVANT le retrait côté Shopify.
      const updates = {};
      removed.forEach((line) => { updates[String(line.key)] = 0; });
      const next = await api('cart/update.js', { updates });
      const count = selected.reduce((sum, line) => sum + Number(line.quantity), 0);
      if (next.item_count !== count) {
        throw new Error('Le panier n’a pas été préparé correctement. Nous allons restaurer les articles.');
      }
      window.location.assign(endpoint('checkout'));
    } catch (error) {
      try {
        if (read(pendingKey)) {
          await restorePending();
          window.location.reload();
          return;
        }
      } catch (_) {
        // Conserver le sauvegarde locale pour une nouvelle tentative de restauration.
      }
      failureText((error && error.message) || 'Impossible de préparer le paiement. Actualise le panier.');
    } finally {
      working = false;
      syncUI();
    }
  }

  document.addEventListener('change', (event) => {
    if (!ready || working || !(event.target instanceof HTMLInputElement)) return;
    const input = event.target;
    if (input.matches('[data-lg-select-item]')) {
      try {
        updateStateFor(input.dataset.lgSelectItem || '', input.checked);
        syncUI();
      } catch (_) { failureText('La sélection ne peut pas être enregistrée sur cet appareil.'); input.checked = true; }
    } else if (input.matches('[data-lg-select-all]')) {
      try {
        if (input.checked) state = { excludedKeys: [], excludedSignatures: [] };
        else if (cartCache) state = {
          excludedKeys: cartCache.items.map((item) => String(item.key)),
          excludedSignatures: cartCache.items.map(signature)
        };
        saveState();
        syncUI();
      } catch (_) { failureText('La sélection ne peut pas être enregistrée sur cet appareil.'); }
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.cart-page, .cart-drawer__footer')) return;
    const submitter = event.submitter;
    if (submitter && submitter.name !== 'checkout') return;
    if (read(pendingKey)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      failureText('Restauration des produits en cours. Actualise ton panier.');
      return;
    }
    if (!ready || !cartCache) return; // Échec de JS : panier natif sans sélection.
    const selected = cartCache.items.filter((line) => !isExcluded(line));
    if (!selected.length || cartCache.items.length !== selected.length) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (selected.length) void beginPartialCheckout();
      else failureText('Sélectionne au moins un article pour passer commande.');
    }
  }, true);

  async function boot() {
    try {
      localStorage.setItem('lg-cart-storage-test', '1');
      localStorage.removeItem('lg-cart-storage-test');
      storageAvailable = true;
    } catch (_) { return; } // Cases cachées et checkout natif conservé.
    try {
      const previous = read(storageKey);
      if (previous && Array.isArray(previous.excludedKeys) && Array.isArray(previous.excludedSignatures)) state = previous;
      const restored = await restorePending();
      if (restored) { window.location.reload(); return; }
      cartCache = await fetchCart();
      ready = true;
      syncUI();
    } catch (error) {
      if (read(pendingKey)) {
        document.body.dataset.lgCartSelectionReady = 'true';
        failureText('Certains articles sont en attente de restauration. Réessaie après actualisation ou contacte la boutique.');
      }
      return;
    }

    // Cart Drawer est reconstruit par Prestige via Section Rendering.
    // Réappliquer la sélection après chaque remplacement du DOM.
    new MutationObserver((records) => {
      if (working || !records.some((r) => Array.from(r.addedNodes).some((n) =>
        n.nodeType === 1 && (n.matches?.('.cart-drawer__items, .order-summary__body, cart-drawer, .lg-cart-selection__line') ||
          n.querySelector?.('[data-lg-select-item]'))))) return;
      syncUI();
      refreshSoon();
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', (event) => { if (event.persisted) window.location.reload(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else void boot();
})();
